import { LocalStorage } from "../assets/types";
import { AuthConsumer } from "./authProvider";

const Logout = () => (
    <AuthConsumer>
    {({ logout }) => {
    localStorage.removeItem(LocalStorage.communityId);
    logout();
    return <span>loading </span>;
}}
</AuthConsumer>
);

export default Logout;
